import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';
import { AppStateService } from 'usermgmt';
import { VlDataService, VlHttpService, HTTPAPIConfig, APIConfigMapping, ImageCropperComponent } from 'shared-library';
import {environment} from '../../../../environments/environment'
import {  ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-new-project',
  templateUrl: './new-project.component.html',
  styleUrls: ['./new-project.component.scss']
})
export class NewProjectComponent implements OnInit, OnDestroy {

  imageSrc = './assets/images/app-icon-placeholder.png';

  projectName: string = '';
  projectDescription: string = '';
  projectIcon!: File;
  tempProjectList: any[] = [];
  application: any[] = [];
  croppedImage: File | undefined;
  defaultImage: File | undefined;
  isFormValid: boolean = false;
  existProject: boolean = false;
  showImageTypeError:boolean = false;
  
  createdProjectId!:string;
  
  projectOperation: string = this.data.projectOperation;
  isDefaultLogo: boolean = this.projectOperation == 'ADD' ? true : false;
  spinnerVisible:boolean=false;
  lastModifiedDate:any
  timeStampEnable:boolean=false;
  isDataChanged: boolean=true;
  projectData = {
    project_name : '',
    project_description : '',
    project_icon_changed: false
  }
  changedProjectData = {
    project_name : '',
    project_description : '',
    project_icon_changed: false

  }
  copyProjectStarted:boolean = false;
  selectedApplication:any = {};
  selectedServer:string = '';
  projectsBasedOnServer:any = [];
  currentEnv = environment.ENV;
  selectedEnv:string = 'dev';
  private destroy$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<NewProjectComponent>,
    public dialog: MatDialog,
    private dataService: VlDataService,
    private http: HttpClient,
    private httpService: VlHttpService,
    private appStateSrv: AppStateService,
    private toastrService:ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  @HostListener('window:keyup.esc') onKeyUp() {
    this.dialogRef.close();
  }

  @HostListener('window:keyup.enter') onEnterUp() {
    if(!this.existProject && !this.isDataChanged && this.projectName !== '') {
      this.onSaveClick();
    }
  }

  ngOnInit(): void {
    if (this.projectOperation === 'EDIT' && this.data.projectData) {
      this.isFormValid = true;
      this.projectName = this.data.projectData.project_name;
      this.projectDescription = this.data.projectData.project_description;
      this.imageSrc = this.data.projectData?.image;
      this.lastModifiedDate = this.data?.projectData?.last_modified_date
      this.timeStampEnable=true;
      this.projectData.project_name = this.data.projectData.project_name?.trim()
      this.projectData.project_description = this.data.projectData.project_description?.trim()

      this.changedProjectData.project_name = this.data.projectData.project_name?.trim()
      this.changedProjectData.project_description = this.data.projectData.project_description?.trim()
    }
  }


  onFileSelected(event: any) {
    this.timeStampEnable=false;
    this.changedProjectData.project_icon_changed = true;
    this.isDataChanged =this.dataService.deepCompare(this.projectData,this.changedProjectData)
    const selectedFile = event.target.files[0];
    if (!selectedFile?.type.startsWith('image/')) {
      this.showImageTypeError = true;
      return;
    }
    if (selectedFile) {
      this.showImageTypeError = false;
      this.isDefaultLogo = false;
      this.cleanupFileReference('projectIcon');
      this.projectIcon = selectedFile;

      this.openCropper(selectedFile);
    }

  }

  descriptionChange() {
    this.changedProjectData.project_description = this.projectDescription?.trim();
    this.isDataChanged =this.dataService.deepCompare(this.projectData,this.changedProjectData)
  }

  removeIcon() {
    if (this.imageSrc && this.imageSrc.startsWith('blob:')) {
      URL.revokeObjectURL(this.imageSrc);
    }
    this.imageSrc = './assets/images/app-icon-placeholder.png';
    this.isDefaultLogo = true;
    this.cleanupFileReference('croppedImage');
    this.cleanupFileReference('projectIcon');
  }
  onCancelClick(): void {
    this.dialogRef.close();
  }

  async editProject(projectId: string, projectName: string): Promise<void> {
    this.spinnerVisible=true;
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['EDIT_PROJECT']);
    const projectNamesLowerCase = this.data.projectNames.map((name:any )=> name.toLowerCase());
    if (projectNamesLowerCase.includes(this.projectName.toLowerCase()) && this.isDataChanged) {
      this.existProject = true;
      this.isFormValid = false;
      this.spinnerVisible=false;
    } else {
      const userMetaInfo = this.appStateSrv.getUserMetaInfo();
      let userID = userMetaInfo && userMetaInfo['userId'] ? userMetaInfo['userId'] : 'null';
      this.isFormValid = true;
      apiConfig.postData = {
        project_id: projectId,
        project_name: this.projectName,
        project_description: this.projectDescription,
        user_id: userID,
      };
  
      try {
        await this.httpService.placeAPICall(apiConfig).toPromise();
  
        const projectIcon = this.croppedImage || this.projectIcon;
        if (projectIcon !== undefined) {
          await this.editProjectLogo(projectId, projectIcon, userID);
          this.spinnerVisible=false;
        }
      } catch (error) {
        this.spinnerVisible = false;
        console.error('Edit project error:', error);
      }
    }
  }

  async editProjectLogo(project_id: string, projectLogo: File, userId: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['EDIT_PROJECT_LOGO']);
      apiConfig.postData = {
        project_id: project_id,
        image: projectLogo,
        key:this.data.projectData?.image?.split("/")?.pop(),
        user_id: userId
      };
      this.httpService.placeAPICall(apiConfig)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            resolve();
          },
          error: (err: any) => {
            this.spinnerVisible = false;
            console.error('Edit project logo error:', err);
            reject(err);
          }
        });
    });
  }

  onProjectNameChange() {
    if(this.data.projectNames.map((name:any) => name.toLowerCase().trim()).includes(this.projectName.toLowerCase().trim())){
      this.existProject=true;
    }else{
      this.existProject=false;
    }
    this.isFormValid = this.projectName.trim() !== '' ;
    this.changedProjectData.project_name = this.projectName?.trim();
    this.isDataChanged=this.dataService.deepCompare(this.projectData,this.changedProjectData)
  }

  async onSaveClick() {
    this.projectName = this.projectName.trim();
    const projectNames = this.data.projectNames;
    const projectNamesLowerCase = projectNames.map((name :any )=> name.toLowerCase());
    if(this.imageSrc == './assets/images/app-icon-placeholder.png'){
      await this.getDefaultImage();
      
    }
    const projectIcon = this.croppedImage || this.projectIcon || this.defaultImage;
   
    if(this.projectOperation === 'EDIT'){
      const projectId = this.data.projectData.project_id;
      const projectName = this.data.projectData.project_name;
      if(!this.isDataChanged){
        await this.editProject(projectId, projectName);
      }else{
        this.isFormValid = false;
      }
    }
    if(this.projectOperation === 'ADD' && projectNamesLowerCase.includes(this.projectName.toLowerCase())){
      this.existProject = true;
      this.isFormValid = false;
    }

    if(this.isFormValid){
      this.existProject = false;
      this.dialogRef.close({
        projectName: this.projectName,
        projectDescription: this.projectDescription,
        projectIcon:projectIcon,
      });
    }
  }

  getDefaultImage(): Promise<File> {
    const defaultImageUrl = './assets/images/app-icon-placeholder.png';
    return new Promise((resolve, reject) => {
      this.http.get(defaultImageUrl, { responseType: 'blob' })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: Blob) => {
            const fileName = 'defaultImage.png';
            const fileType = 'image/png';
            const lastModified = Date.now();
            this.cleanupFileReference('defaultImage');
            const defaultImageFile = new File([data], fileName, { 
              type: fileType, 
              lastModified: lastModified 
            });
            this.defaultImage = defaultImageFile;
            resolve(defaultImageFile);
          },
          error: (error) => {
            console.error('Failed to fetch the default image:', error);
            reject(error);
          }
        });
    });
  }

  openCropper(selectedimage:File){
    const dialogRef =  this.dialog.open(ImageCropperComponent,{
       disableClose: true,
       data: {
        imageFile:selectedimage
      }
    })

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (typeof (result) !== 'boolean' && result !== undefined) {

          if (this.imageSrc && this.imageSrc.startsWith('blob:')) {
            URL.revokeObjectURL(this.imageSrc);
          }
          this.cleanupFileReference('croppedImage');
          this.imageSrc = result.croppedImageUrl;
          this.projectIcon = result.croppedImageFile;
          this.changedProjectData.project_icon_changed = true;
          this.isDataChanged = this.dataService.deepCompare(this.projectData, this.changedProjectData);
        }
      });
  }

  // Helper method to clean up file references
  private cleanupFileReference(fileProperty: keyof this): void {
    const fileRef = this[fileProperty] as File | undefined;
    if (fileRef) {
      (this[fileProperty] as any) = undefined;
    }
  }

  // Helper method to clean up blob URLs
  private cleanupBlobUrls(): void {
    if (this.imageSrc && this.imageSrc.startsWith('blob:')) {
      URL.revokeObjectURL(this.imageSrc);
    }
  }

  private performCleanup(): void {
    this.cleanupBlobUrls();
    
    this.cleanupFileReference('projectIcon');
    this.cleanupFileReference('croppedImage');
    this.cleanupFileReference('defaultImage');
    
    this.tempProjectList = [];
    this.application = [];
    
    this.projectData = {
      project_name: '',
      project_description: '',
      project_icon_changed: false
    };
    
    this.changedProjectData = {
      project_name: '',
      project_description: '',
      project_icon_changed: false
    };
  }

  copyProject(){
    this.copyProjectStarted = true;
    this.fetchProjectsBasedOnServer();
  }

  fetchProjectsBasedOnServer() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['FETCH_DIFFERENT_ENV_PROJECTS']);
    apiConfig.options = {
      params:{
        'env': this.selectedServer,
      }
    }
    this.httpService.placeAPICall(apiConfig)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.projectsBasedOnServer = data.response;
        },
        error: (err: any) => {
          console.error('Error fetching projects:', err);
        }
      });
  }

  onCopy(){
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['MIGRATE_PROJECT']);
      apiConfig.postData = {
        source_project_id:this.selectedApplication,
        source_env_server:this.selectedServer
      };
      this.httpService.placeAPICall(apiConfig)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
             this.toastrService.success(data.message ?? `Project migration from ${this.selectedServer} Server has started. You will receive an email confirmation once the migration is successfully completed.`);
             this.dialogRef.close('');
          },
          error: (err: any) => {
            this.spinnerVisible = false;
            console.error('Edit project logo error:', err);
          }
        });
  }

  ngOnDestroy(): void {
    this.performCleanup();
    this.destroy$.next();
    this.destroy$.complete();
    this.copyProjectStarted = false;
  }
}